<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime : 2019-12-30 16:17:15
 * @LastEditors  : Please set LastEditors
 -->
<template>
<div id="page_container" class="invoice-wrapper">
    <div class="page">
        <div id="main-container" class="main-container">
            <div class="invoice-item-wrappper">
                <div class="invoice-item">
                    <div class="title">发票类型</div>
                    <div class="content arrow" @click="onShowInvoiceType">{{invoice.invoiceTypeStr}}</div>
                </div>
                <div class="invoice-item typeItem">
                    <div class="title">抬头类型</div>
                    <van-radio-group v-model="invoice.radio" class="content radio" @change="onTypeChange">
                        <van-radio name="1" class="firstRadio">个人</van-radio>
                        <van-radio name="2">企业</van-radio>
                    </van-radio-group>
                </div>
                <div class="invoice-item">
                    <div class="title">发票抬头</div>
                    <van-cell-group class="content">
                        <van-field v-model="invoice.invoiceTitle" input-align="right" placeholder="发票抬头" />
                    </van-cell-group>
                    <div class="arrow chooseInvoice" @click="onChooseInvoiceTitle"></div>
                </div>
                <div class="invoice-item" v-if='invoice.invoiceTitleType === "2"'>
                    <div class="title">税号</div>
                    <van-cell-group class="content input">
                        <van-field v-model="invoice.taxNumber" input-align="right" placeholder="纳税人识别号" />
                    </van-cell-group>
                </div>
                <div v-show="isShowCompany">
                    <div class="invoice-item">
                        <div class="title">开户银行</div>
                        <van-cell-group class="content input">
                            <van-field v-model="invoice.depositBank" input-align="right" placeholder="选填" />
                        </van-cell-group>
                    </div>
                    <div class="invoice-item">
                        <div class="title">银行账号</div>
                        <van-cell-group class="content input">
                            <van-field v-model="invoice.bankAccount" input-align="right" placeholder="选填" />
                        </van-cell-group>
                    </div>
                    <div class="invoice-item">
                        <div class="title">企业地址</div>
                        <van-cell-group class="content input">
                            <van-field v-model="invoice.enterpriseAddress" input-align="right" placeholder="选填" />
                        </van-cell-group>
                    </div>
                    <div class="invoice-item">
                        <div class="title">企业电话</div>
                        <van-cell-group class="content input">
                            <van-field v-model="invoice.enterprisePhone" input-align="right" placeholder="选填" />
                        </van-cell-group>
                    </div>
                </div>
                <div class="pulldown" v-show="isShow">
                    <div class="enlarge" @click="onPullDown">
                        <i class="icon" ref="pulldown"></i>
                    </div>
                </div>
            </div>
            <!-- <div class="uninvoice" @click="onGoOrder">
                <span class="text">本次不开具发票，继续下单</span>
                <i class="icon"></i>
            </div> -->
            <div class='submitBox'>
                <van-button type="primary"  round size="large" @click="onSubmit">完成</van-button>
                <van-button type="default" @click="onGoOrder" round size="large" style="margin-top:15px;">取消</van-button>
            </div>
        </div>
        <van-popup v-model="showInvoiceType" position="bottom">
            <van-picker :columns="columns" :show-toolbar="true" title="发票类型" @change="onInvoiceTypeChange" @confirm="onInvoiceTypeConfirm" @cancel="onInviceTypeCancel" />
        </van-popup>
    </div>
</div>
</template>

<script>
import { Toast } from 'vant';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';
import { mapMutations, mapGetters } from 'vuex';
export default {
    components: {
        [Toast.name]: Toast
    },
    data() {
        return {
            routerParams: {},
            showInvoiceType: false,
            columns: ['电子发票', '纸质发票'],
            invoice: {
                invoiceTypeStr: '电子发票',
                invoiceTitleTypeStr: '个人',
                invoiceTitleType: '1',
                invoiceType: 1,
                dutyParagraph: '', // 发票类型
                radio: '1', // 抬头类型
                radio2: '', //  默认抬头
                depositBank: '', // 开户银行
                bankAccount: '', // 开户账号
                enterpriseAddress: '', // 企业地址
                enterprisePhone: '', // 企业电话
                invoiceTitle: '', // 发票抬头
                taxNumber: '' // 税号
            },
            isShowCompany: false,
            isShow: false
        };
    },
    esvReady() {
        this.routerParams = this.$route.params;
        // document.title = '个人信息';
    },
    esvShow() {
        const ths = this;
        this.ESVStorage.getSavedValue('invoiceArr', (data) => {
            ths.invoiceArr = data;
        });
        this.ESVStorage.getSavedValue('invoiceIndex', (data) => {
            ths.invoiceIndex = data;
        });
        ths.invoiceArr[this.$route.params.index] && ths.invoiceArr[this.$route.params.index].invoiceTitle ? this.invoice = ths.invoiceArr[this.$route.params.index] : this.invoice = {
            invoiceType: 1,
            invoiceTypeStr: '电子发票',
            invoiceTitleType: '1',
            invoiceTitleTypeStr: '个人',
            dutyParagraph: '', // 发票类型
            radio: '1', // 抬头类型
            radio2: '', //  默认抬头
            depositBank: '', // 开户银行
            bankAccount: '', // 开户账号
            enterpriseAddress: '', // 企业地址
            enterprisePhone: '', // 企业电话
            invoiceTitle: '', // 发票抬头
            taxNumber: '' // 税号
        };
    },
    methods: {
        ...mapMutations(['changeOrderDetails']),
        // 完成
        onSubmit() {
            const ths = this;
            const params = {};
            if (ths.invoice.invoiceTitleType === '1') {
                if (ths.invoice.invoiceTitle.length <= 0) {
                    Toast('请填写发票抬头');
                    return false;
                }
            }
            if (ths.invoice.invoiceTitleType === '2') {
                if (ths.invoice.invoiceTitle.length <= 0) {
                    Toast('请填写发票抬头');
                    return false;
                }
                if (ths.invoice.taxNumber.length <= 0) {
                    Toast('请填写发票税号');
                    return false;
                }
            }
            for (var attr in ths.invoice) {
                if (ths.invoice[attr] !== '') {
                    params[attr] = ths.invoice[attr];
                }
            }
            if (this.routerParams.type === '1') {
                const { orderCode, totalAmount } = this.routerParams;
                const { invoiceType, invoiceTypeStr, invoiceTitleTypeStr, ...mParams } = params;
                this.makeInvoice({ ...mParams, depositType: invoiceType, orderCode, totalAmount });
            } else {
                const arr = this.invoiceArr ? this.invoiceArr : [];
                arr[Number(this.invoiceIndex)] = params;
                this.ESVStorage.putSavedValue('invoiceArr', arr);
                ths.esvBackPage(1);
            }
        },
        makeInvoice(params) {
            this.$doRequest({
                url: '/invoice/makeInvoice',
                params: { ...params, merchantInfo: JSON.stringify(this.merchantInfoSwitch) },
                before: function() {
                    this.loading = toastLoading();
                },
                complete: function() {
                    clearToastLoading(this.loading);
                }
            },
            (data) => {
                this.changeOrderDetails({ statusName: 'invoiceType', status: params.depositType });
                this.changeOrderDetails({ statusName: 'invoiceSerialNumber', status: data.result.invoiceSerialNumber });
                this.esvReloadPage({ name: 'OPInvoiceDetails', params: { invoiceSerialNumber: data.result.invoiceSerialNumber } });
            });
        },
        // 发票类型弹出框
        onShowInvoiceType() {
            this.showInvoiceType = true;
        },
        // 发票抬头
        onChooseInvoiceTitle() {
            this.invoiceHeaderClick();
        },
        invoiceHeaderClick () {
            const ths = this;
            // let opId = ths.$route.query.opid;
            // if (opId && opId.length > 0) {
            // } else {
            //     opId = 'oRgEnw_CIlxkQjBy2yEM3tBShrBY';
            // }
            // let Url = location.href.split('#')[0];
            // let params = {
            //     opId: opId,
            //     authUrl: Url
            // };
            // OWCNet.doRequest(
            //     {
            //         url: '/wechat/queryWechatConfig',
            //         params: params,
            //         complete: function() {}
            //     },
            //     function(data) {
            // wx.config({
            //     beta: true,
            //     debug: true,
            //     appId: data.result.appId,
            //     timestamp: data.result.timestamp,
            //     nonceStr: data.result.nonce,
            //     signature: data.result.signature,
            //     jsApiList: ['chooseInvoiceTitle']
            // });
            wx.ready(function () {
                wx.invoke(
                    'chooseInvoiceTitle',
                    {
                        scene: '1'
                    },
                    function (data) {
                        if (data.err_msg === 'chooseInvoiceTitle:ok') {
                            const res = JSON.parse(
                                data.choose_invoice_title_info
                            );
                            ths.invoice.invoiceTitle = res.title ? res.title : '';
                            ths.invoice.taxNumber = res.taxNumber ? res.taxNumber : '';
                            if (ths.invoice.radio === '2') {
                                ths.invoice.enterpriseAddress = res.companyAddress ? res.companyAddress : '';
                                ths.invoice.enterprisePhone = res.telephone ? res.telephone : '';
                                ths.invoice.depositBank = res.bankName ? res.bankName : '';
                                ths.invoice.bankAccount = res.bankAccount ? res.bankAccount : '';
                            }
                        }
                    }
                );
            });
            wx.error(function (res) {
                alert('wx error');
            });
            // }, function(data) {
            //     Toast(data.message);
            // }
            // );
        },
        // 发票类型change事件
        onInvoiceTypeChange(picker, value, index) {
            // console.log(picker);
            // console.log(value);
        },
        // 选择发票类型确定事件
        onInvoiceTypeConfirm(value) {
            if (value === '电子发票') {
                this.invoice.invoiceType = 1;
            } else if (value === '纸质发票') {
                this.invoice.invoiceType = 2;
            } else {
                this.invoice.invoiceType = 0;
                this.invoice.invoiceTitleType = '';
            }
            this.invoice.invoiceTypeStr = value;
            this.showInvoiceType = false;
        },
        // 选择发票类型取消事件
        onInviceTypeCancel() {
            this.showInvoiceType = false;
        },
        // 不开具发票回到上一页
        onGoOrder() {
            if (this.routerParams.type === '1') {
                this.esvBackPage(1);
            } else {
                const arr = this.invoiceArr;
                arr[Number(this.invoiceIndex)] = {};
                this.ESVStorage.putSavedValue('invoiceArr', arr);
                this.esvOpenPage({
                    name: 'OPConfirmOrder'
                });
            }
        },
        // 企业和个人切换
        onPullDown() {
            this.isShowCompany = !this.isShowCompany;
            const degs = this.isShowCompany === true ? -90 : 90;
            this.$refs.pulldown.style.transform = `rotate(${degs}deg)`;
            this.$refs.pulldown.style.transition = 'all 0.3s';
        },
        onTypeChange(val) {
            this.invoice.invoiceTitleType = val;
            if (val === '1') {
                this.invoice.invoiceTitleTypeStr = '个人';
            } else {
                this.invoice.invoiceTitleTypeStr = '企业';
            }
            if (val === '1') {
                this.isShowCompany = false;
                this.isShow = false;
            } else if (val === '2') {
                // this.isShowCompany = true;
                this.isShow = true;
            }
        }
    },
    computed: {
        ...mapGetters([
            'merchantInfoSwitch'
        ])
    }
};
</script>

<style lang="scss" scoped>
.invoice-wrapper {
    background-color: transparent !important;
}
.invoice-item-wrappper {
    padding: 0 12px;
    // margin: 10px 0;
    background: #fff;

    .invoice-item {
        height: 50px;
        display: flex;
        align-items: center;
        color: #414141;
        font-size: 14px;
        border-bottom: 0.5px solid #E3E2E2;
        .input {
            border: none;
            background: transparent;
        }
        .title {
            flex: 1;
        }

        .arrow {
            background: url(../assets/img/goods/right.png) right center no-repeat;
            background-size: 10px 15px;
            padding: 0 12px;
        }

        .chooseInvoice {
            height: 100%;
        }

        .radio {
            display: flex;
            height: 24px;

            .firstRadio {
                margin-right: 20px;
            }
        }

        .wordColor {
            color: #BEBEC5;
        }
    }

    .default {
        border-bottom: none;
    }

    .pulldown {
        height: 40px;
        text-align: center;
        // line-height: 35px;
        padding: 10px;

        .enlarge {
            display: inline-block;
            padding: 10px;
            .icon {
                display: inline-block;
                background: url(../assets/img/goods/right.png) right center;
                background-size: 7px 15px;
                transform: rotate(90deg);
                width: 12px;
                height: 15px;
            }
        }
    }
}

.uninvoice {
    background: #fff;
    height: 50px;
    line-height: 50px;
    padding: 0 12px;
    font-size: 14px;
    display: flex;
    align-items: center;

    .text {
        flex: 1;
    }

    .icon {
        background: url(../assets/img/goods/right.png) right center no-repeat;
        background-size: 10px 15px;
        padding: 10px;
    }
}

.submit {
    background: #EE2E50;
    font-size: 14px;
    height: 44px;
    line-height: 44px;
    width: 80%;
    margin: 0 10%;
    text-align: center;
    color: #fff;
    border-radius: 22px;
}

.van-cell {
    padding: 0;
}
.van-hairline--top-bottom::after {
    border: 0!important;
}
.submitBox{
    width:100%;
    // background: #fff;
    padding:8px 35px;
    margin-top: 50px;
}
</style>
